// libraries
import React, { useState } from "react";

// styles
import styles from "./styles.module.scss";

// components
import Switch from "./Switch/Switch";
import RegisterForm from "./RegisterForm";
import LoginForm from "./LoginForm";
import ForgotForm from "./ForgotForm";
import VerifyForm from "./VerifyForm";
import PasswordForm from "./PasswordForm";

const Content = ({ initailIndex }) => {
  // states
  const [index, setIndex] = useState(initailIndex);

  const renderForm = () => {
    switch (index) {
      case 1:
        return (
          <>
            <h1>Log In</h1>
            <LoginForm changeForm={setIndex} />
          </>
        );
      case 2:
        return (
          <>
            <h1>Create Account</h1>
            <RegisterForm changeForm={setIndex} />
          </>
        );
      case 3:
        return (
          <>
            <h1>Forgot Password?</h1>
            <ForgotForm changeForm={setIndex} />
          </>
        );
      case 4:
        return (
          <>
            <h1>Enter Verification Code?</h1>
            <VerifyForm changeForm={setIndex} />
          </>
        );
      case 5:
        return (
          <>
            <h1>Create New Password</h1>
            <PasswordForm changeForm={setIndex} />
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className={styles.form}>
      <div className={styles.inner}>
        {index < 3 && <Switch index={index} setIndex={setIndex} />}
        <div className={styles.wrap}>{renderForm()}</div>
      </div>
    </div>
  );
};

export default Content;
